const submittersMap = new WeakMap();
const submitHandler = (event) => {
  const form = event.target instanceof HTMLFormElement ? event.target : undefined;
  const submitter = event.submitter || undefined;

  if (form) {
    if (submitter) {
      submittersMap.set(form, submitter);
    } else {
      submittersMap.delete(form);
    }
  }
};

const uploadStartHandler = (event) => {
  const input = event.target;
  const { form } = input;
  form.setAttribute('aria-busy', 'true');
  const submitter = submittersMap.get(form);
  if (submitter) {
    submitter.disabled = true;
  }
};

const uploadEndHandler = (event) => {
  const input = event.target;
  const { form } = input;
  form.removeAttribute('aria-busy');
  const submitter = submittersMap.get(form);
  if (submitter) {
    submitter.disabled = false;
  }
};

export const start = () => {
  document.addEventListener('submit', submitHandler, true);
  document.addEventListener('direct-upload:start', uploadStartHandler);
  document.addEventListener('direct-upload:end', uploadEndHandler);
};
